import type { FaqItem } from '@/data/faqData'
import {ChevronDown} from 'lucide-react'
import { useState } from 'react'

interface FAQAccordionProps {
  items: FaqItem[]
}

function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <div className="divide-y divide-slate-200 border border-slate-200 rounded-xl bg-white overflow-hidden">
      {items.map((item, index) => {
        const isOpen = openIndex === index
        const panelId = `faq-panel-${index}`
        const buttonId = `faq-button-${index}`
        return (
          <div key={item.question}>
            <h3 className="m-0">
              <button
                type="button"
                id={buttonId}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="w-full flex items-center justify-between gap-3 text-left px-4 sm:px-5 py-4 font-semibold text-slate-900 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 focus-visible:ring-inset"
              >
                <span>{item.question}</span>
                <ChevronDown
                  className={isOpen ? 'h-5 w-5 text-emerald-600 flex-shrink-0 rotate-180 transition-transform' : 'h-5 w-5 text-slate-400 flex-shrink-0 transition-transform'}
                  aria-hidden="true"
                />
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={buttonId}
              className={isOpen ? 'block px-4 sm:px-5 pb-4' : 'hidden px-4 sm:px-5 pb-4'}
            >
              <p className="text-sm text-slate-600 leading-relaxed">{item.answer}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default FAQAccordion
